import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Fetch album detail

export const BLOGS_ALBUM_DETAIL_FETCH_TRIGGER = "BLOGS_ALBUM_DETAIL_FETCH_TRIGGER";
export interface BlogsAlbumDetailFetchTriggerAction {
    readonly type: typeof BLOGS_ALBUM_DETAIL_FETCH_TRIGGER;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export const BLOGS_ALBUM_DETAIL_FETCH_REQUEST = "BLOGS_ALBUM_DETAIL_FETCH_REQUEST";
export interface BlogsAlbumDetailFetchRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_ALBUM_DETAIL_FETCH_REQUEST;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export interface BlogsAlbumDetailFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
        comments: number[];
    };
}
export const BLOGS_ALBUM_DETAIL_FETCH_SUCCESS = "BLOGS_ALBUM_DETAIL_FETCH_SUCCESS";
export interface BlogsAlbumDetailFetchSuccessAction extends APISuccessAction<BlogsAlbumDetailFetchNormalizedResponse> {
    readonly type: typeof BLOGS_ALBUM_DETAIL_FETCH_SUCCESS;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}
export const BLOGS_ALBUM_DETAIL_FETCH_FAILURE = "BLOGS_ALBUM_DETAIL_FETCH_FAILURE";
export interface BlogsAlbumDetailFetchFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_ALBUM_DETAIL_FETCH_FAILURE;
    readonly username: string;
    readonly postSlug: string;
    readonly accessKey: string;
}

export const blogsAlbumDetailFetchTrigger = (
    username: string,
    postSlug: string,
    accessKey: string,
): BlogsAlbumDetailFetchTriggerAction => ({
    type: BLOGS_ALBUM_DETAIL_FETCH_TRIGGER,
    username,
    postSlug,
    accessKey,
});
export const blogsAlbumDetailFetchApi = {
    request: (
        username: string,
        postSlug: string,
        accessKey: string,
    ): BlogsAlbumDetailFetchRequestAction => ({
        type: BLOGS_ALBUM_DETAIL_FETCH_REQUEST,
        username,
        postSlug,
        accessKey,
    }),
    success: (
        username: string,
        postSlug: string,
        accessKey: string,
        response: BlogsAlbumDetailFetchNormalizedResponse,
    ): BlogsAlbumDetailFetchSuccessAction => ({
        type: BLOGS_ALBUM_DETAIL_FETCH_SUCCESS,
        username,
        postSlug,
        accessKey,
        response,
    }),
    failure: (
        username: string,
        postSlug: string,
        accessKey: string,
        error: any,
    ): BlogsAlbumDetailFetchFailureAction => ({
        type: BLOGS_ALBUM_DETAIL_FETCH_FAILURE,
        username,
        postSlug,
        accessKey,
        error,
    }),
};
